import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

// Connects to data-controller="countdown"
export default class extends Controller {
  static targets = ["counter"]
  static values = {
    seconds: Number,
    redirectUrl: String
  }

  connect() {
    this.remainingSeconds = this.secondsValue
    this.updateCounter()
    this.timer = setInterval(() => this.countdown(), 1000)
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  countdown() {
    this.remainingSeconds -= 1
    
    if (this.remainingSeconds <= 0) {
      clearInterval(this.timer)
      visit(this.redirectUrlValue)
      return
    }
    
    this.updateCounter()
  }

  updateCounter() {
    this.counterTarget.textContent = this.remainingSeconds
  }
}
